export { Fade } from './Fade';
export type { FadeProps } from './Fade';
